import React from "react";
import AppRouter from "./AppRouter";
import Store from "./store/Store";
import "./css/main.css";

export default () => {
    return(
        <Store>
            <AppRouter />
        </Store>
    )
}
